// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ZuOU9PoZZejIwdpjiBw","header":"_2WhixL7fkn1zn9PhlgFhv0","content":"_2u4Cx-DDYG5Sp-9ZmEEQ4W"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/Main/style/Layout.pcss
// module id = 1426
// module chunks = 0